// Licensed under Gnu Public License version 2
// Copyright (c) 2024 (original work) Open Assessment Technologies SA ;

import config from './config.js';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard.js';

export default [
    {
        path: [config.mySessions],
        guard: getPermissionsGuard([{ resource: 'portal.my-session', scopes: ['view'] }]),
        controller: () => import('./controllers/mySessions')
    },
    {
        path: [config.enrollmentSessions],
        guard: getPermissionsGuard([
            { resource: 'portal.my-session', scopes: ['view'] },
            { resource: 'portal.payment', scopes: ['create'] }
        ]),
        controller: () => import('./controllers/enrollmentSessions')
    }
];
